import { render, staticRenderFns } from "./PnrLocationDetails.vue?vue&type=template&id=0d2b845a&"
import script from "./PnrLocationDetails.vue?vue&type=script&lang=js&"
export * from "./PnrLocationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports